import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { Toaster } from "@/components/ui/toaster";
import { ConfirmDialogProvider } from "@/components/ui/confirm-dialog";
// Drapeaux pays en SVG (page /plugins) — les emojis-drapeaux ne s'affichent pas
// sur Chrome/Edge sous Windows. Import global : la CSS reference les SVG charges
// a la demande quand une classe `fi fi-xx` est rendue.
import "flag-icons/css/flag-icons.min.css";

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <Toaster />
    <ConfirmDialogProvider />
  </StrictMode>,
)
